import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

import { OrderStoreSelector } from '@common/selectors/order.selector';
import { OrderKeys } from '@config/keys/order.keys';
import {
  DoodOrderModel,
  DoodOrderPaymentInvoiceGenerationStatus,
  DoodOrderPaymentModel,
} from '@store/order/order.model';

import {
  ORDER_INVOICE_BLOCK_EMPTY_VM,
  OrderInvoiceBlockDataSource,
  OrderInvoiceBlockViewModel,
} from './order-invoice-block-view-model';

@Injectable()
export class OrderInvoiceBlockStoreDataSource implements OrderInvoiceBlockDataSource {
  private readonly orderSelector = inject(OrderStoreSelector);
  private readonly invoiceStatus = DoodOrderPaymentInvoiceGenerationStatus.generated;

  readonly vm$: Observable<OrderInvoiceBlockViewModel> = this.orderSelector.selectActive.pipe(
    map(order => {
      const unwrapped = this.unwrapOrder(order);
      const payments = this.paymentsWithInvoiceFile(unwrapped);
      return payments.length ? { payments } : ORDER_INVOICE_BLOCK_EMPTY_VM;
    }),
  );

  private unwrapOrder(order: DoodOrderModel | null | undefined): DoodOrderModel | undefined {
    if (!order) {
      return undefined;
    }

    return order[OrderKeys.MultiShop]
      ? (order[OrderKeys.ChildOrders]?.[0] as DoodOrderModel | undefined)
      : order;
  }

  private paymentsWithInvoiceFile(
    order: DoodOrderModel | null | undefined,
  ): DoodOrderPaymentModel[] {
    if (!order?.payments?.length) {
      return [];
    }

    return order.payments.filter(
      payment =>
        payment.invoice_generation_status === this.invoiceStatus &&
        !!payment.invoice_file_path?.length,
    );
  }
}
